import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { ProtocolSubjectResponse } from "../../models/dtos";

interface ProtocolSubjectsListProps {
  protocolId: number;
  protocolSubjects: ProtocolSubjectResponse[];
  selectedSubjects: ProtocolSubjectResponse[];
  onSelectionChange: (subjects: ProtocolSubjectResponse[]) => void;
}

const ProtocolSubjectsList = ({
  protocolId: _protocolId,
  protocolSubjects,
  selectedSubjects,
  onSelectionChange,
}: ProtocolSubjectsListProps) => {
  return (
    <Card title="Списък дисциплини" className="mt-4 shadow-4">
      <DataTable
        value={protocolSubjects}
        stripedRows
        selectionMode="multiple"
        selection={selectedSubjects}
        onSelectionChange={(e) => onSelectionChange(e.value)}
        dragSelection
      >
        <Column selectionMode="multiple" headerStyle={{ width: "3rem" }} />
        <Column header="Номер на дисциплина" style={{ width: "140px" }} sortField="subjectId" sortable />
        <Column field="name" header="Дисциплина" sortable />
        <Column field="semester" header="Семестър" sortable />
        <Column field="cipher" header="Шифър" sortable />
        <Column field="code" header="Код" sortable />
      </DataTable>
    </Card>
  );
};

export default ProtocolSubjectsList;
